/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResetPasswordModel } from '../models/ResetPasswordModel';
import type { UserDTO } from '../models/UserDTO';
import type { UserViewDTO } from '../models/UserViewDTO';
import type { UserViewDTOODataListResponse } from '../models/UserViewDTOODataListResponse';
import type { WelcomeModel } from '../models/WelcomeModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns UserViewDTOODataListResponse Success
     * @throws ApiError
     */
    public static getBackendUsers(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<UserViewDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backend/Users',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns UserDTO Success
     * @throws ApiError
     */
    public static postBackendUsers(
requestBody?: UserDTO,
): CancelablePromise<UserDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backend/Users',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns UserViewDTO Success
     * @throws ApiError
     */
    public static getBackendUsers1(
key: number,
): CancelablePromise<UserViewDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backend/Users/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns UserDTO Success
     * @throws ApiError
     */
    public static putBackendUsers(
key: number,
requestBody?: UserDTO,
): CancelablePromise<UserDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/backend/Users/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteBackendUsers(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/backend/Users/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public static postBackendUsersResetpassword(
requestBody?: ResetPasswordModel,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backend/Users/resetpassword',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param requestBody 
     * @returns boolean Success
     * @throws ApiError
     */
    public static postBackendUsersWelcomemail(
requestBody?: WelcomeModel,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backend/Users/welcomemail',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param requestBody 
     * @returns string Success
     * @throws ApiError
     */
    public static postBackendUsersResettoken(
requestBody?: ResetPasswordModel,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backend/Users/resettoken',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

}
